import { Modal } from "react-bootstrap";
import Gmailimage from '../../assets/socialimg/2.png'
import twitterimage from '../../assets/socialimg/4.png'
import instagramimage from '../../assets/socialimg/3.png'
import whatsappimage from '../../assets/socialimg/5.png'
import facebookimage from '../../assets/socialimg/6.png'
import linkedinimage from '../../assets/socialimg/7.png'
import '../../pages/referscreen/refer.css'
import { showCustomSwal } from "../customswal/Customswal";



const CustomSocial = ({ show, hide, data,ismeet }) => {
  console.log(data,"data")
  const formattedText = data?.sharemsg?.replace(/<br\s*\/?>/g, '\n');


  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(formattedText);
      showCustomSwal("Referral link copied to clipboard");
    } catch (err) {
     showCustomSwal("Failed to copy!");
    }
  };
  const openInstagram = () => {
    window.open("https://www.instagram.com/", "_blank", "noopener,noreferrer");
  };
  const openFacebook = () => {
    const message = encodeURIComponent(formattedText);
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${window.location.href}&quote=${message}`;
    window.open(facebookUrl, '_blank', 'noopener,noreferrer');
  };
  const openTwitter = () => {
    const message = encodeURIComponent(formattedText);
    const twitterUrl = `https://twitter.com/intent/tweet?text=${message}`;
    window.open(twitterUrl, '_blank', 'noopener,noreferrer');
  };
      
  const openGmailCompose = () => {
    const subject = encodeURIComponent(` ${ismeet ? "Google Meet Link":"TrackHR Referral Code"} `);
    const body = encodeURIComponent(formattedText);
    const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=&su=${subject}&body=${body}`;
    window.open(gmailUrl, '_blank', 'noopener,noreferrer');
  };
 
  const openLinkedin = () => {
    // const pageUrl = encodeURIComponent('https://trackhr.co.in');
    const title = encodeURIComponent('TrackHRApp');
    const summary = encodeURIComponent(formattedText);
  
    const linkedinUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${window.location.href}&title=${title}&summary=${summary}`;
  
    window.open(linkedinUrl, '_blank', 'noopener,noreferrer');
  };
  
  
  const openwhatsapp = () => {
    const message = encodeURIComponent(formattedText);
    const whatsappUrl = `https://web.whatsapp.com/send?text=${message}`;
    window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
  };
  

  return (
    <div>
      <Modal show={show} onHide={hide} centered>
        <Modal.Header closeButton>
          <Modal.Title style={{color:"#29b6f6", fontSize:"20px"}}> {ismeet ? "Google Meet Link" : "Refer Us"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-center align-items-center gap-3 flex-wrap mt-2 mb-2">
          <div className="pointcur" variant="light" onClick={()=>{
            copyToClipboard()
           setTimeout(()=>{
            openFacebook()
           },400)
          }}>
          <img src={facebookimage} className=" img-fluid imgsize2" />
</div>
            <div className="pointcur" variant="light" onClick={openwhatsapp} >
            <img src={whatsappimage} className=" img-fluid imgsize2" />
            </div>

            <div  className="pointcur" variant="light" onClick={()=>{
copyToClipboard()
setTimeout(() => {
  openTwitter()
}, 400);
            }}>
            <img src={twitterimage} className=" img-fluid imgsize" />
</div>

            <div  className="pointcur" variant="light" onClick={()=>{
copyToClipboard()
setTimeout(() => {
  openLinkedin()
}, 400);
            }}>
            <img src={linkedinimage} className=" img-fluid imgsize2" />
</div>

            <div   className="pointcur" variant="light" onClick={openGmailCompose}>
              <img src={Gmailimage} className=" img-fluid imgsize" />
            </div>
            <div   className="pointcur" variant="light" onClick={()=>{
              copyToClipboard()
            setTimeout(() => {
              openInstagram()
            }, 400);
            }}>
              <img src={instagramimage} className=" img-fluid imgsize" />
            </div>

          </div>

          <div className="text-center mt-3">
          </div>
          <div className=" d-flex justify-content-center align-items-center gap-3 flex-wrap mt-4">
            <div variant="primary" onClick={copyToClipboard} className="btnupdate">
              Copy {ismeet ? "Google Meet" : "Referral"} Link
            </div>
          </div>

          <center>
           
          </center>

        </Modal.Body>
      </Modal>
    </div>
  );
};

export default CustomSocial;
